import Skeleton from "react-loading-skeleton";

export function TableSkeleton({
  rows = 5,
  columns,
}: {
  rows?: number;
  columns: number;
}) {
  return (
    <tbody>
      {[...Array(rows)].map((_, r) => (
        <tr key={r}>
          {[...Array(columns)].map((_, c) => (
            <td key={c} className="p-3">
              <Skeleton height={24} />
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  );
}
